import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Slider } from 'antd'
import styled from 'styled-components'

const propTypes = {}

// styled components
const JobTitleArea = styled.div`
  background-color: transparent;
  padding-top: 2px;
  padding-left: 5px;
  padding-right: 5px;
`

const statusMarks = {
  0: 'Design',
  33: 'Manufacturing',
  66: 'Work in Progress',
  100: {
    label: <strong>Complete</strong>
  }
}

class JobTitle extends Component {
  handleStatusChange = value => {
    this.props.handleJobStatusChange(value)
  }

  transformJobStatus = status => {
    switch (status.toLowerCase()) {
      case 'complete':
        return 100
      case 'manufacturing':
        return 33
      case 'work in progress':
        return 66
      default:
        return 0
    }
  }

  render() {
    const { payload } = this.props.jobDetails
    if (payload && payload.data) {
      return (
        <JobTitleArea>
          <div className="row">
            <div className="col-lg-5 col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/jobs">Jobs</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {payload.data.name}
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-none d-sm-block col-lg-7 col-md-6">
              <div className="steps">
                {!this.props.maintenenceJob && (
                  <Slider
                    marks={statusMarks}
                    step={null}
                    defaultValue={this.transformJobStatus(payload.data.status)}
                    disabled={!this.props.isEditing}
                    tipFormatter={null}
                    onChange={this.handleStatusChange}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 jobTitle">
              <h2>
                <i className="fa fa-map-marker" aria-hidden="true" />
                {payload.data.name}
              </h2>
            </div>
          </div>
        </JobTitleArea>
      )
    } else {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    }
  }
}

const mapStateToProps = ({ jobDetails }, ownProps) => ({
  jobDetails
})

JobTitle.propTypes = propTypes
export default withRouter(connect(mapStateToProps)(JobTitle))



// WEBPACK FOOTER //
// ./src/components/JobTitle.js